/**
 * Membership form — Adesão (empresas / entidades / outros)
 */

(function () {
    "use strict";

    var form = document.getElementById("mf-form");
    if (!form) return;

    var statusEl = document.getElementById("mf-status");
    var submitBtn = form.querySelector(".mf-submit-btn");
    var submitLabel = submitBtn ? submitBtn.querySelector(".mf-submit-label") : null;
    var fileInput = document.getElementById("mf-logotipo");
    var fileLabel = document.getElementById("mf-file-label");
    var fileName = document.getElementById("mf-file-name");
    var segmentoSelect = form.querySelector("[data-mf-segmento]");

    function strings(key) {
        return (window.mfConfig && mfConfig.strings && mfConfig.strings[key]) || "";
    }

    // ── File input feedback ──
    if (fileInput && fileName && fileLabel) {
        fileInput.addEventListener("change", function () {
            if (fileInput.files && fileInput.files[0]) {
                fileName.textContent = fileInput.files[0].name;
                fileLabel.classList.add("has-file");
            } else {
                fileName.textContent = strings("fileDefault");
                fileLabel.classList.remove("has-file");
            }
        });
    }

    // ── Custom multiselect dropdowns ──
    var multiselects = Array.prototype.slice.call(form.querySelectorAll(".mf-multiselect"));

    function msBoxes(ms) {
        return Array.prototype.slice.call(ms.querySelectorAll('.mf-ms-option input[type="checkbox"]'));
    }

    // Options hidden by the segmento filter must not count as selections.
    function msCheckedVisible(ms) {
        return msBoxes(ms).filter(function (cb) {
            return cb.checked && !cb.closest(".mf-ms-option").hidden;
        });
    }

    function msRefreshLabel(ms) {
        var toggle = ms.querySelector(".mf-ms-toggle");
        var valueEl = ms.querySelector(".mf-ms-value");
        var checked = msCheckedVisible(ms);

        if (!checked.length) {
            valueEl.textContent = ms.dataset.placeholder || "";
            toggle.classList.add("is-placeholder");
            return;
        }

        valueEl.textContent = checked
            .map(function (cb) {
                var span = cb.parentNode.querySelector("span");
                return span ? span.textContent.trim() : "";
            })
            .join(", ");
        toggle.classList.remove("is-placeholder");
    }

    function msClose(ms) {
        ms.classList.remove("is-open");
        ms.querySelector(".mf-ms-toggle").setAttribute("aria-expanded", "false");
    }

    function msCloseAll(except) {
        multiselects.forEach(function (ms) {
            if (ms !== except) msClose(ms);
        });
    }

    multiselects.forEach(function (ms) {
        var toggle = ms.querySelector(".mf-ms-toggle");

        toggle.addEventListener("click", function () {
            var willOpen = !ms.classList.contains("is-open");
            msCloseAll(ms);
            ms.classList.toggle("is-open", willOpen);
            toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        });

        ms.addEventListener("change", function () {
            msRefreshLabel(ms);
            if (fieldWrap(ms).classList.contains("is-invalid")) {
                validateField(ms);
            }
        });

        msRefreshLabel(ms);
    });

    document.addEventListener("click", function (e) {
        if (!e.target.closest(".mf-multiselect")) msCloseAll(null);
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") msCloseAll(null);
    });

    // ── "Outro" companion inputs ──
    var otherCheckboxes = Array.prototype.slice.call(form.querySelectorAll(".mf-ms-other"));

    function otherFieldFor(control) {
        return form.querySelector('[data-mf-other-field="' + control + '"]');
    }

    function syncOtherField(cb) {
        var wrap = otherFieldFor(cb.dataset.otherFor);
        if (!wrap) return;
        wrap.hidden = !cb.checked;
        if (!cb.checked) {
            var input = wrap.querySelector("input");
            if (input) input.value = "";
        }
    }

    otherCheckboxes.forEach(function (cb) {
        cb.addEventListener("change", function () {
            syncOtherField(cb);
        });
        syncOtherField(cb);
    });

    // ── Segmento-driven filtering of the categoria dropdowns ──
    // Each option carries the segmento option ids that make it relevant
    // (read from the field's conditional_logic in the Entity Manager).
    function applySegmentoFilter() {
        if (!segmentoSelect) return;
        var segmento = segmentoSelect.value;

        form.querySelectorAll(".mf-ms-option[data-segmentos]").forEach(function (option) {
            var allowed = option.dataset.segmentos.split(",");
            var visible = segmento !== "" && allowed.indexOf(segmento) !== -1;

            option.hidden = !visible;
            if (!visible) {
                var cb = option.querySelector('input[type="checkbox"]');
                if (cb) cb.checked = false;
            }
        });

        // Hide a whole control when the segmento leaves it without any option.
        multiselects.forEach(function (ms) {
            var options = Array.prototype.slice.call(ms.querySelectorAll(".mf-ms-option"));
            var conditional = options.filter(function (o) {
                return o.hasAttribute("data-segmentos");
            });
            if (!conditional.length) return;

            var anyVisible = options.some(function (o) {
                return !o.hidden;
            });

            fieldWrap(ms).hidden = !anyVisible;
            if (!anyVisible) {
                clearError(ms);
                msClose(ms);
            }
            msRefreshLabel(ms);
        });
    }

    if (segmentoSelect) {
        segmentoSelect.addEventListener("change", applySegmentoFilter);
        applySegmentoFilter();
    }

    // ── Client-side validation ──
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function requiredControls() {
        return Array.prototype.slice
            .call(form.querySelectorAll("[required], .mf-multiselect[data-required]"))
            .filter(function (el) {
                var wrap = fieldWrap(el);
                return !wrap.hidden && !el.disabled;
            });
    }

    function fieldWrap(el) {
        return el.closest(".mf-field") || el.closest(".mf-checkbox-wrap") || el.parentNode;
    }

    function setError(el, message) {
        var wrap = fieldWrap(el);
        wrap.classList.add("is-invalid");
        var err = wrap.querySelector(".mf-field-error");
        if (!err) {
            err = document.createElement("span");
            err.className = "mf-field-error";
            err.setAttribute("role", "alert");
            wrap.appendChild(err);
        }
        err.textContent = message;
    }

    function clearError(el) {
        var wrap = fieldWrap(el);
        wrap.classList.remove("is-invalid");
        var err = wrap.querySelector(".mf-field-error");
        if (err) err.textContent = "";
    }

    function validateField(el) {
        if (el.classList && el.classList.contains("mf-multiselect")) {
            // A checked "Outro" counts as a selection even though it posts no value.
            var other = el.querySelector(".mf-ms-other");
            if (!msCheckedVisible(el).length && !(other && other.checked)) {
                setError(el, strings("selectRequired") || strings("required"));
                return false;
            }
            clearError(el);
            return true;
        }

        var val = (el.value || "").trim();

        if (el.type === "checkbox") {
            if (!el.checked) {
                setError(el, strings("required"));
                return false;
            }
        } else if (!val) {
            setError(el, el.tagName === "SELECT" ? strings("selectRequired") || strings("required") : strings("required"));
            return false;
        } else if (el.type === "email" && !EMAIL_RE.test(val)) {
            setError(el, strings("invalidEmail"));
            return false;
        }

        clearError(el);
        return true;
    }

    function focusable(el) {
        return el.classList && el.classList.contains("mf-multiselect") ? el.querySelector(".mf-ms-toggle") : el;
    }

    function validateForm() {
        var firstInvalid = null;
        requiredControls().forEach(function (el) {
            if (!validateField(el) && !firstInvalid) {
                firstInvalid = el;
            }
        });
        return firstInvalid;
    }

    // Clear a field's error as soon as it becomes valid again
    form.querySelectorAll("[required]").forEach(function (el) {
        var evt = el.type === "checkbox" || el.tagName === "SELECT" ? "change" : "input";
        el.addEventListener(evt, function () {
            if (fieldWrap(el).classList.contains("is-invalid")) {
                validateField(el);
            }
        });
    });

    // ── Status helper ──
    function showStatus(message, type) {
        statusEl.textContent = message;
        statusEl.className = "mf-status is-" + type;
        statusEl.hidden = false;
        statusEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    function hideStatus() {
        statusEl.hidden = true;
        statusEl.className = "mf-status";
    }

    function clearAllErrors() {
        form.querySelectorAll(".is-invalid").forEach(function (wrap) {
            wrap.classList.remove("is-invalid");
            var err = wrap.querySelector(".mf-field-error");
            if (err) err.textContent = "";
        });
    }

    // Applies per-field messages returned by the server.
    function applyServerErrors(fields) {
        var firstInvalid = null;
        Object.keys(fields).forEach(function (name) {
            var el =
                form.querySelector('[name="' + name + '"]') ||
                form.querySelector('[name="' + name + '[]"]');
            if (!el) return;

            var target = el.closest(".mf-multiselect") || el;
            setError(target, fields[name]);
            if (!firstInvalid) firstInvalid = target;
        });
        if (firstInvalid) focusable(firstInvalid).focus();
    }

    // ── Loading state ──
    function setLoading(loading) {
        submitBtn.disabled = loading;
        if (submitLabel) {
            submitLabel.textContent = loading ? strings("submitting") : strings("submit");
        }
    }

    function resetForm() {
        form.reset();

        if (fileName) {
            fileName.textContent = strings("fileDefault");
            if (fileLabel) fileLabel.classList.remove("has-file");
        }

        clearAllErrors();
        otherCheckboxes.forEach(syncOtherField);
        applySegmentoFilter();
        multiselects.forEach(msRefreshLabel);
    }

    // ── Submit handler ──
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        hideStatus();

        var firstInvalid = validateForm();
        if (firstInvalid) {
            var msg = firstInvalid.name === "rgpd" ? strings("acceptTerms") : strings("checkFields");
            showStatus(msg, "error");
            focusable(firstInvalid).focus();
            return;
        }

        setLoading(true);

        var tokenPromise = window.hcpRecaptcha
            ? window.hcpRecaptcha.getToken("membership")
            : Promise.resolve("");

        tokenPromise.then(function (token) {
            var formData = new FormData(form);
            formData.append("recaptcha_token", token);

            fetch(mfConfig.ajaxUrl, {
                method: "POST",
                body: formData,
            })
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    if (data.success) {
                        resetForm();
                        showStatus((data.data && data.data.message) || strings("success"), "success");
                    } else {
                        if (data.data && data.data.fields) {
                            applyServerErrors(data.data.fields);
                        }
                        showStatus((data.data && data.data.message) || strings("error"), "error");
                    }
                })
                .catch(function () {
                    showStatus(strings("error"), "error");
                })
                .finally(function () {
                    setLoading(false);
                });
        });
    });
})();
